import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
//import router from "./router";
import router from "@/router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import { initTheme } from "@/core/services/ThemeService";
import {initOffline} from "@/core/services/Offline";
import {registerServiceWorker} from "@/core/services/ServiceWorker";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import Clipboard from "vue3-clipboard";

import "@/core/plugins/prismjs";
import "bootstrap";
import "@/assets/css/theme-tokens.css";

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

initTheme();
// the saved answers of the server, and the banner when it can not be reached
initOffline();

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(Clipboard, {
  autoSetContainer: true,
  appendToBody: true,
});

const toastOptions = {
  // You can set your default options here
};
app.use(Toast, toastOptions);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");

// the application itself is kept in the browser: it opens without a connection
registerServiceWorker();
